import {
  ADMIN_SUBMIT_USER_KYC,
  ADMIN_SUBMIT_USER_KYC_SUCCESS,
  ADMIN_SUBMIT_USER_KYC_FAILURE,
} from "../../Action/actionTypes";

const initialState = {
  loading: false,
  error: null,
  data: null,
};

export const adminSubmitKycReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADMIN_SUBMIT_USER_KYC:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case ADMIN_SUBMIT_USER_KYC_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case ADMIN_SUBMIT_USER_KYC_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload || "An error occurred",
      };
    default:
      return state;
  }
};